module.exports = __webpack_public_path__ + "media/images/top-parts-03-4006cfbabf376ad578934acf177f9b94.jpg";